import {FilterAlt, Replay, SearchRounded} from "@mui/icons-material";
import {Button, Collapse, Grid, OutlinedInput, Paper} from "@mui/material";
import {useTranslation} from "react-i18next";
import SearchIcon from '@mui/icons-material/Search';
import * as React from "react";
import {useContext, useState} from "react";

import * as Yup from 'yup';
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {Stack} from "@mui/material/";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";

interface AdvancedFilterProps {
    validationObj: any,
    fields: any,
    filters: any,
    setFilters: Function,
    mainFields?: any,
    searchInput?: any,
    onReset: Function,
    setSearchInput?: Function,
    defaultValues: any
}

const AdvancedFilter = ({
    validationObj,
    fields,
    mainFields,
    searchInput,
    setSearchInput,
    filters,
    setFilters,
    defaultValues,
    onReset,
}: AdvancedFilterProps) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'blackList'});
    const tr = useTranslation(['translation']);
    const [advancedFilters, setAdvancedFilters] = useState(false);
    const { globalData } = useContext(GlobalContext);

    const { watch, handleSubmit, control, reset, formState, setValue } = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(Yup.object(validationObj))
    });

    const watchAll = watch();

    const handleDoSearch = (data: any) => {
        setFilters(data);
        setAdvancedFilters(false);
    }

    return (
        <>
            <Paper elevation={1} sx={{ padding: "16px"}}>
                <form onSubmit={handleSubmit(data => handleDoSearch(data), errors => console.log(errors))}>
                    <Grid container spacing={1} justifyContent={"space-between"}>
                        {setSearchInput && <Grid item xs={3}>
                            <OutlinedInput
                                fullWidth
                                inputProps={{ maxLength: 120 }}
                                value={searchInput}
                                onChange={(event) => {
                                    setSearchInput(event?.target.value)
                                }}
                                size="small"
                                startAdornment={<SearchIcon />}
                            />
                        </Grid>}
                        {!setSearchInput && mainFields &&                        
                            <Grid  container xs={9} item spacing={1}>
                                {Object.keys(mainFields).slice(0, 3).map(f =>
                                    <Grid item xs={4} key={f}>
                                        <Controller
                                            control={control}
                                            name={f}
                                            render={({ field, fieldState: { error }, formState }) => (
                                                mainFields[f](field, error, formState, watchAll, setValue)
                                            )}
                                        />
                                    </Grid>                                
                            )}
                            </Grid>
                        }
                             
                        <Grid item xs={3} justifyContent={"flex-end"} alignItems={"center"}>
                            <Stack direction={"row"} alignItems={"center"} spacing={2}>
                                <Button disabled={(!searchInput && !formState.isDirty)}
                                    variant="text" size="small" color="accent"
                                    onClick={() => {
                                        reset(defaultValues);
                                        if (setSearchInput)
                                            setSearchInput("");
                                        setAdvancedFilters(false)
                                    }}>
                                    <Replay />
                                    {t('buttons.reset')}
                                </Button>
                                {advancedFilters ?
                                    <Button variant="text" size="small" color="primary" onClick={() => {
                                        setAdvancedFilters(false)
                                    }}>
                                        <FilterAlt />
                                        {t('buttons.close')}
                                    </Button>
                                    :
                                    <Button variant="text" size="small" color="accent" onClick={() => {
                                        setAdvancedFilters(true)
                                    }}>
                                        <FilterAlt />
                                        {t('buttons.advancedFilters')}
                                    </Button>}
                                <Button type={'submit'} size={'icon'} color={'accent'}><SearchRounded /></Button>
                            </Stack>
                        </Grid>

                        {!setSearchInput && mainFields &&
                            <>
                                {Object.keys(mainFields).slice(3).map(f =>
                                    <Grid item xs={3} key={f}>
                                        <Controller
                                            control={control}
                                            name={f}
                                            render={({ field, fieldState: { error }, formState }) => (
                                                mainFields[f](field, error, formState, watchAll)
                                            )}
                                        />
                                    </Grid>
                                )}
                            </>
                        }
                        <Grid item xs={3} />
                    </Grid>

                    <Collapse in={advancedFilters}>
                        <Grid container spacing={1}>
                            <Grid container item spacing={1} xs={12}>
                                {Object.keys(fields).map(f =>
                                    <Grid item xs={3} key={f}>
                                        <Controller
                                            control={control}
                                            name={f}
                                            render={({ field, fieldState: { error }, formState }) => (
                                                fields[f](field, error, formState, watchAll, setValue)
                                            )}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Collapse>
                </form>
            </Paper>
        </>
    )
}

export default AdvancedFilter;